module.exports = __webpack_public_path__ + "static/why-dungeons-logo-ba98ef6044a41f993ae4e2e24db13caa.png";